import { apiRequest, auth } from './api';
import { buildApiUrl } from '../config/api';

export interface UploadedFile {
  id: string;
  originalFilename: string;
  systemFilename: string;
  uploadedAt: string;
  fileSize: number;
  uploadedBy: string;
  status: 'pending' | 'processing' | 'completed' | 'error';
}

export interface UploadStats {
  today: number;
  week: number;
  month: number;
}

export const uploadApi = {
  async getConfig(): Promise<{maxFiles: number, maxFileSize: number, allowedTypes: string[]}> {
    return apiRequest('/api/upload/config');
  },

  async getPendingFiles(): Promise<UploadedFile[]> {
    return apiRequest<UploadedFile[]>('/api/upload/pending');
  },

  async getFailedFiles(): Promise<UploadedFile[]> {
    return apiRequest<UploadedFile[]>('/api/upload/failed');
  },

  async getUploadStats(): Promise<UploadStats> {
    return apiRequest<UploadStats>('/api/upload/stats');
  },

  async uploadFiles(files: File[]): Promise<any> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await fetch(buildApiUrl('/api/upload/files'), {
      method: 'POST',
      headers: auth.getAuthHeaders(),
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.details || error.error || 'Upload failed');
    }

    return response.json();
  },

  async deleteFile(id: string): Promise<void> {
    return apiRequest(`/api/upload/files/${id}`, {
      method: 'DELETE',
    });
  },

  async getFileUrl(id: string): Promise<{ url: string }> {
    return apiRequest<{ url: string }>(`/api/upload/download/${id}`);
  },

  async retryFailedFile(id: string): Promise<{ success: boolean; message: string }> {
    return apiRequest<{ success: boolean; message: string }>(`/api/upload/failed/${id}/retry`, {
      method: 'POST',
    });
  }
};